<template>
	<div class="disclaimer_section text-align-center border-bottom container-general">
		<span class="fw-bold">Quotazione richiesta il {{ infobike.giorno_creazione + ' ' + infobike.mese_creazione + ' ' +
			infobike.anno_creazione }}</span>. Valida solo nel mese solare in corso di elaborazione anche per Comprare e
		Assicurare:
		<span class="fw-bold text-primary"> {{ infobike.mese_creazione_successivo + ' ' + infobike.anno_creazione_successivo
		}}</span>
	</div>
</template>

<script>
export default {
	name: 'DisclaimerSection',
	props: {
		infobike: {
			type: Object,
			required: true,
		},
	}
};
</script>



// WEBPACK FOOTER //
// resources/js/app/components/DisclaimerSection.vue